// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rejection-item[data-v-b954f51a] {\n  margin-bottom: 4px;\n}\n.rejection-item[data-v-b954f51a]:last-child {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
